export function clearEmptyProps(obj) {
  if (!obj) {
    return obj;
  }
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value != null && value !== ''));
}
